const o=[{opacity:0},{opacity:1}];export{o as fadeInKeyframes};
